import { SidebarDivider as CoreSidebarDivider } from '@backstage/core-components';
import { useTheme } from '@material-ui/core/styles';

export const SidebarDivider = () => {
  const theme = useTheme();

  return <CoreSidebarDivider style={{ background: theme.palette.divider }} />;
};
